import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { EasypayImportFileBatch } from './easypay-import-file-batch.interface';
import { EasypayImportFileBatchService } from './easypay-import-file-batch.service';
const service = new EasypayImportFileBatchService();

interface EasypayImportFileBatchState {
   easypayImportFileBatchesOverview?: PaginatedResponse<EasypayImportFileBatch>;
}

const state: EasypayImportFileBatchState = {};

const getters = {
   easypayImportFileBatchesOverview(state: EasypayImportFileBatchState) {
      return state.easypayImportFileBatchesOverview;
   },
};

const mutations = {
   SET_EASYPAY_IMPORT_FILE_BATCHES_OVERVIEW(state: EasypayImportFileBatchState, overview: PaginatedResponse<EasypayImportFileBatch>) {
      return (state.easypayImportFileBatchesOverview = overview);
   },
};

const actions = {
   async addEasypayImportFileBatch(context: any, importBatch: any) {
      const batch = await service.postEasypayImportFileBatches(importBatch);
      context.commit('batch/ADD_BATCH', batch, { root: true });
      return batch;
   },
   async getEasypayImportFileBatches(context: any) {
      return await service.getEasypayImportFileBatches().then((overview) => {
         context.commit('SET_EASYPAY_IMPORT_FILE_BATCHES_OVERVIEW', overview);
         return overview;
      });
   },
};

export default {
   namespaced: true,

   state,
   getters,
   mutations,
   actions,
};
